module.exports = __webpack_public_path__ + "img/pr-6.f3eba879.png";